import React, { useRef, useState, useEffect } from 'react'
import './wallet.sass'
import './viewerWallet.sass'
import Header from '../../components/common/Header'
import { CreditCard, WalletButtonRed, WalletTabBar, WithdrawViewer } from '../../components/wallet'
import { Input } from '../../components/common/Input'



export default function ViewerWallet() {

    const transactionRef = useRef(0)
    const balanceRef = useRef(0)
    const paymentRef = useRef(0)
    const [addConf, setAddConf] = useState(false);

    const [isMobile, setIsMobile] = useState(false);
    const updateView = (v) => {
        if (v <= 830) {
            setIsMobile(true);
            try {
                paymentRef.current.style.display = "none";
                transactionRef.current.style.display = "none";

                balanceRef.current.style.maxWidth = "100%"
                balanceRef.current.style.flex = "100%"
                balanceRef.current.style.paddingRight = "0px"

            } catch (e) { }
        }
        else {
            setIsMobile(false)
            try {
                transactionRef.current.style.display = "block";
                paymentRef.current.style.display = "block";
                balanceRef.current.style.display = "block";


                balanceRef.current.style.maxWidth = "33.3%"
                balanceRef.current.style.flex = "33.3%"
                balanceRef.current.style.paddingRight = "10px"

                transactionRef.current.style.maxWidth = "33.3%"
                transactionRef.current.style.flex = "33.3%"
                transactionRef.current.style.paddingLeft = "10px"

                paymentRef.current.style.maxWidth = "33.3%"
                paymentRef.current.style.flex = "33.3%"
                paymentRef.current.style.padding = "0px 5px"
            } catch (e) {

            }
        }
    }

    useEffect(() => {
        updateView(window.innerWidth)
        if(bodyWidth < 580){
            document.getElementById('mobileWrapper').style.display = "none";
        } else {
            document.getElementById('mobileWrapper').style.display = "flex";
        }

    }, [])

    window.addEventListener('resize', v => {
        updateView(v.target.innerWidth)

    })

    // useEffect to watch for width height change
	const [bodyWidth, setBodyWidth] = useState(document.body.clientWidth);
    const updateWindowWidth = () => {
        // setBodyHeight(document.body.clientHeight);
        setBodyWidth(document.body.clientWidth);
	}
	
	useEffect(() => {
		window.addEventListener('resize', updateWindowWidth);
		if(bodyWidth < 580){
            document.getElementById('mobileWrapper').style.display = "none";
        } else {
            document.getElementById('mobileWrapper').style.display = "flex";
        }
    }, [bodyWidth]);

    const updateTab = (e, setIsActive) => {
        if (e == 0) {
            try {
                balanceRef.current.style.display = "block";
                balanceRef.current.style.maxWidth = "100%"
                balanceRef.current.style.flex = "100%"
                balanceRef.current.style.paddingRight = "0px"
                setIsActive(0);
                paymentRef.current.style.display = "none";
                transactionRef.current.style.display = "none";
            } catch (e) { }
        } else if (e == 1) {
            try {
                paymentRef.current.style.display = "block";
                paymentRef.current.style.maxWidth = "100%"
                paymentRef.current.style.flex = "100%"
                paymentRef.current.style.paddingRight = "0px"
                setIsActive(1);
                transactionRef.current.style.display = "none";
                balanceRef.current.style.display = "none";
            } catch (e) { }
        } else {
            try {
                transactionRef.current.style.display = "block";
                transactionRef.current.style.maxWidth = "100%"
                transactionRef.current.style.flex = "100%"
                transactionRef.current.style.paddingRight = "0px"
                setIsActive(2);
                paymentRef.current.style.display = "none";
                balanceRef.current.style.display = "none";
            } catch (e) { }
        }
    }

    const addMoney = () => {
        setAddConf(!addConf);
    }
    return (
        <div id="walletWrapper">
            {isMobile ? <div id="walletTabBar"> <WalletTabBar onUpdate={updateTab} text="Wallet Balance" img="tip" text2="Payment Option" img2="creditCard" text3="Transactions" img3="transaction" /> </div> : '' }
            <div id="walletRow">

                <div ref={balanceRef} id="walletLCol">
                    { !isMobile ? <Header img='tip_a.svg' text="Wallet Balance" />: ''}
                    <p id="walletNormalText">Your available money collected from subscriptions and tips. You can withdraw this balance anytime.</p>
                    <div id="walletTotalBalance">
                        <p id="walletTotalBalanceText">$2345</p>
                    </div>
                    <div className='addPaymentOption'>
                        <img src={require('../../assets/icons/bank.svg')} alt="addPayment" />
                        <p>Add payment option</p>
                    </div>
                    <p id="walletBoldText" style={{marginBottom: '0px'}}>Add Money</p>
                    <p id='walletNormalText' style={{marginTop: '10px', marginBottom: '10px'}}>Enter your desired money to top-up. Minimum amount is $5.</p>
                    <Input placeholder="Amount of money" icon='tip.svg' type="text" />
                    <div className='withdrawConf'>
                        {addConf ? <img src={require('../../assets/icons/checkbox_a.svg')} onClick={addMoney} alt="checked" /> : <img src={require('../../assets/icons/checkbox.svg')} onClick={addMoney} alt="unchecked" />}
                        <p id="walletNormalText" style={{marginLeft: '10px'}}>Top-Up confirmation</p>
                    </div>
                    <div className="addMoneyButton">
                        <p>ADD MONEY</p>
                    </div>
                </div>

                <div ref={paymentRef} id="walletCCol">
                    { !isMobile ? <Header img='creditCard_a.svg' text="Payment Options" />: ''}
                    <div>
                        <div className='paymentOptionHeader'>
                            <p id='walletBoldText'>Your Card</p>
                            <WalletButtonRed text='ADD CARD' />
                        </div>
                        <p id="walletNormalText">The charges on your credit card statement will appear as “Lovr Online”</p>
                    </div>
                    <CreditCard cardnumber='1234' cardtype='mastercard' cardexp='12/24' isVerified={true} isDefault={true} />
                    <CreditCard cardnumber='5749' cardtype='visa' cardexp='12/24' isVerified={false} isDefault={true} />
                    <CreditCard cardnumber='4312' cardtype='mastercard' cardexp='12/24' isVerified={true} isDefault={false} />
                   <div style={{display: 'flex', alignItems: 'center', flexDirection: 'column'}}>
                        <p className='walletMediumBoldText'>We are fully compliant with Payment Card Industry Data Security Standards.</p>
                        <img src={require('../../assets/img/card.png')} alt='cards' style={{margin: 'auto', width: '100%'}} />
                   </div>
                </div>

                <div ref={transactionRef} id="walletRCol">
                    { !isMobile ? <Header img='transaction_a.svg' text="Transactions" />: ''}
                    <WithdrawViewer status="added" time="2 days ago @5:30am" amount="36" />
                    <WithdrawViewer status="tip" name="Aryan" time="2 days ago @5:30am" amount="36" />
                    <WithdrawViewer status="subscribe" name="Aryan" time="2 days ago @5:30am" amount="36" />
                    <WithdrawViewer status="added" time="2 days ago @5:30am" amount="36" />
                    <WithdrawViewer status="tip" name="Aryan" time="2 days ago @5:30am" amount="36" />
                    <WithdrawViewer status="subscribe" name="Aryan" time="2 days ago @5:30am" amount="36" />
                </div>
            </div>
        </div>
    )
}
